<template>
  <div class="widget">
    <h1>
        Exclusive Curly Themes Support Center
    </h1>
    <img src="../assets/support.svg">
    <p>This form is only for clients who already purchased one of our products. For pre-sale questions, please use <a href="http://curlythemes.com/support/presale-question/">this form</a></p>
      <div>
          <template v-if="! hasTokens()">
              <a href="https://my.curlythemes.com/.netlify/functions/authenticate" class="btn btn-large btn-register">Connect with Envato</a>
          </template>
          <template v-else-if=" hasTokens() && ! isTokenValid() ">
              <router-link :to="{ path: '/logged' }" class="btn btn-large btn-register">Reconnect with Envato</router-link>
          </template>
          <template v-else-if=" hasTokens() && isTokenValid() ">
              <router-link :to="{ path: '/products' }" class="btn btn-large btn-register">My Envato Products</router-link>
          </template>
      </div>

      <a class="green-link" href="#" v-on:click.prevent="how = true">How does this work?</a>

      <div class="tooltip" v-show="how">
        <div class="how">
            <h2>How does this work?</h2>
            If you connect with <strong>Envato</strong>, we can automatically verify if you purchased our product and if you have an active support subscription. You will then be able to submit a ticket without the purchase code.
            <br><br>
            <button class="btn-request" v-on:click.prevent="how = false">Ok, got it</button>
        </div>
    </div>
    <div class="grey-line">
      <span>or</span>
    </div>
    <div>
        <router-link :to="{path: '/purchase-code'}"  class="btn btn-large btn-manual">Enter purchase code manually</router-link>
    </div>
  </div>
</template>

<script>
    import tokensMixins from '@/mixins/tokens'
export default {
    name: 'HelloWorld',
    mixins: [ tokensMixins ],
    data: function(){
        return {
            how: false
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h2{
        font-weight: 500;
        color: #000;
    }
</style>
